import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/elevated-card/elevated-card.js';
      import {ObcElevatedCardPosition, ObcElevatedCardSize, ObcElevatedCardTag} from '@oicl/openbridge-webcomponents/dist/components/elevated-card/elevated-card.js';

      export interface Props {
     position?: ObcElevatedCardPosition;
     size?: ObcElevatedCardSize;
     overrideTag?: ObcElevatedCardTag | undefined;
     isClickable?: boolean;
     info?: boolean;
     graphicBorder?: boolean;
     border?: boolean;
     hasAction?: boolean;
     hasLeadingIcon?: boolean;
     hasTrailingIcon?: boolean;
     hasGraphic?: boolean;
     hasStatus?: boolean;
     compact?: boolean;
     directAction?: boolean;
     href?: string | undefined;
     target?: string | undefined
   }

      
  
      export type {ObcElevatedCardPosition, ObcElevatedCardSize, ObcElevatedCardTag} from '@oicl/openbridge-webcomponents/dist/components/elevated-card/elevated-card.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcElevatedCard',
  props: {
    position: {},
    size: {},
    overrideTag: {},
    isClickable: { type: Boolean },
    info: { type: Boolean },
    graphicBorder: { type: Boolean },
    border: { type: Boolean },
    hasAction: { type: Boolean },
    hasLeadingIcon: { type: Boolean },
    hasTrailingIcon: { type: Boolean },
    hasGraphic: { type: Boolean },
    hasStatus: { type: Boolean },
    compact: { type: Boolean },
    directAction: { type: Boolean },
    href: {},
    target: {}
  },
  emits: ["action-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onActionClick: (event: CustomEvent<unknown>) => emit('action-click', event as CustomEvent<unknown>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-elevated-card',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})